
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class ProductionItemsDialog extends _Ext.MFGTransItemEditorDialog<ProductionItemsRow> {
        protected getFormKey() { return ProductionItemsForm.formKey; }
        protected getLocalTextPrefix() { return ProductionItemsRow.localTextPrefix; }
        protected getNameProperty() { return ProductionItemsRow.nameProperty; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public departmentid: number;
        public partyId: number;
        public form = new ProductionItemsForm(this.idPrefix);
        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initMFGBOMEditor(this, this.form.BOMDetails, Config);
            //q.initDetailEditor(this,this.form.NewBOMDetails, Config);
            q.hideCategorylinks(this.element);
            q.hideEditorToolbar(this.form.BOMDetails); 
            q.SetCategoryFullWidth(this.form.TransDate);
            q.SetCategoryFullWidth(this.form.BOMDetails);

            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.Pieces);;

            q.hideEditorLabel(this.form.BOMDetails);

            var fieldEditor: JQuery = this.form.BagNo.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );

            this.form.BagNo.changeSelect2(e => {

                let workorderdetails;

                WIPMovementSelectService.List({ BagNo: this.form.BagNo.value }, response => workorderdetails = response.Entities[0], { async: false });

                this.form.BagNo.value = workorderdetails.BagNo;


                this.form.Pieces.value = workorderdetails.Pieces;
                this.form.DiamondPieces.value = workorderdetails.DiamondPieces;
                this.form.DiamondWeight.value = workorderdetails.DiamondWeight;
                this.form.OtherPieces.value = workorderdetails.OtherPieces;
                this.form.OtherWeight.value = workorderdetails.OtherWeight;
                this.form.StonePieces.value = workorderdetails.StonePieces;
                this.form.StoneWeight.value = workorderdetails.StoneWeight;
                this.form.Weight.value = workorderdetails.Weight;
                this.form.NetWeight.value = workorderdetails.Weight;
                this.form.DepartmentId.value = workorderdetails.DepartmentId.toString(); 
                this.form.ProductId.value = workorderdetails.ProductId.toString();
                this.form.Line_No.value = workorderdetails.LineNo.toString();
                this.form.AttributeId.value = workorderdetails.AttributeId.toString();
                this.form.ProductCode.value = workorderdetails.ProductCode;
                this.form.TransDate.value = workorderdetails.TransDate;
                this.form.VoucherNo.value = workorderdetails.VoucherNo;
                this.form.Purity.value = workorderdetails.Purity;
                this.form.PureWeight.value = workorderdetails.PureWeight;
                this.form.CompanyId.value = workorderdetails.CompanyId;
                this.form.FinancialYearId.value = workorderdetails.FinancialYearId;
                this.form.RefTransId.value = workorderdetails.TransId.toString();
                this.form.RefTransItemId.value = workorderdetails.TransItemId.toString();
                this.form.RefVoucherId.value = workorderdetails.VoucherTypeId;
                this.form.OrderTypeId.value = workorderdetails.RefVoucherId;
                this.form.OrderTransId.value = workorderdetails.TransId;
                this.form.OrderTransItemId.value = workorderdetails.TransItemId;

                if (workorderdetails.OrderTypeId == 16) {
                    let salesdetails: SalesOrder.SalesOrderRow;
                    SalesOrder.SalesOrderService.GetCustomerandProductDetails({ EntityId: this.form.OrderTransId.value }, response => salesdetails = response.Entity, { async: false });

                    this.form.OrderNo.value = salesdetails.VoucherNo;
                    this.form.CustomerName.value = salesdetails.LedgerName;


                } else if (workorderdetails.OrderTypeId == 47) {

                    let posdetails: Retail.POSOrderRow;
                    Retail.POSOrderService.GetCustomerandProductDetails({ EntityId: this.form.OrderTransId.value }, response => posdetails = response.Entity, { async: false });

                    this.form.OrderNo.value = posdetails.VoucherNo;
                    this.form.CustomerName.value = posdetails.CustomerName;

                }
                let bomdetails: WIPTransactionRow[];
                WIPTransactionService.MFGBOMList({ BagNo: this.form.BagNo.value }, response => bomdetails = response.Entities, { async: false });
                var newbomdetails = [];
                for (var i = 0; i < bomdetails.length; i++) {
                    var value = bomdetails[i];

                    var newbom: ProductionBOMRow = {
                        AttributeId: value.AttributeId,
                        ItemTypeId: value.ItemTypeId,
                        CalcOnId: value.CalcOnId,
                        ProductCode: value.ProductCode,
                        Attribute: value.Attribute,
                        BomProductId: value.ProductId,
                        BagNo: value.BagNo,
                        ProductId: value.ProductId,
                        Pieces: value.Pieces,
                        Line_No: value.Line_No,
                        PureWeight: value.PureWeight,
                        Purity: value.Purity == null ? 0 : value.Purity,
                        Weight: value.Weight,
                        RefTransId: value.TransId,
                        RefVoucherId: value.VoucherTypeId,
                        IsCustomerItem: value.IsCustomerItem
                    };
                    newbomdetails.push(newbom);

                }
                this.form.BOMDetails.setdata(newbomdetails);
                this.CalculateTotals();


            });

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

        }


        protected inplaceSearchClick(e: any): void {
            if (!this.isViewMode()) {
                if (this.form.BOMDetails.getItems().length == 0) {
                    var grid = WIPMovementSelectGrid;
                    var filters: _Ext.SelectGridFilters = {
                        DepartmentId: Q.parseInteger(this.form.DepartmentId.value)
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Work Order", GridFilters: filters 
                    });

                    pickerDialog.onSuccess = (selectedItems: WIPMovementRow[]) => {

                        if (selectedItems.length > 0) {

                            this.form.BagNo.value = selectedItems[0].BagNo;

                            this.form.ItemTypeId.value = selectedItems[0].ItemTypeId;
                            this.form.Pieces.value = selectedItems[0].Pieces;
                            this.form.DiamondPieces.value = selectedItems[0].DiamondPieces;
                            this.form.DiamondWeight.value = selectedItems[0].DiamondWeight;
                            this.form.OtherPieces.value = selectedItems[0].OtherPieces;
                            this.form.OtherWeight.value = selectedItems[0].OtherWeight;
                            this.form.StonePieces.value = selectedItems[0].StonePieces;
                            this.form.StoneWeight.value = selectedItems[0].StoneWeight;
                            this.form.Weight.value = selectedItems[0].Weight;
                            this.form.NetWeight.value = selectedItems[0].Weight;
                            this.form.DepartmentId.value = selectedItems[0].DepartmentId.toString(); 
                            this.form.ProductId.value = selectedItems[0].ProductId.toString();
                            this.form.Line_No.value = selectedItems[0].Line_No.toString();
                            this.form.AttributeId.value = selectedItems[0].AttributeId.toString();
                            this.form.ProductCode.value = selectedItems[0].ProductCode;
                            this.form.TransDate.value = selectedItems[0].TransDate;
                            this.form.VoucherNo.value = selectedItems[0].VoucherNo;
                            this.form.Purity.value = selectedItems[0].Purity;
                            this.form.PureWeight.value = selectedItems[0].PureWeight;
                            this.form.CompanyId.value = selectedItems[0].CompanyId;
                            this.form.FinancialYearId.value = selectedItems[0].FinancialYearId;
                            this.form.RefTransId.value = selectedItems[0].TransId.toString();
                            this.form.RefTransItemId.value = selectedItems[0].TransItemId.toString();
                            this.form.RefVoucherId.value = selectedItems[0].VoucherTypeId;
                            this.form.OrderTypeId.value = selectedItems[0].OrderTypeId;
                            this.form.OrderTransId.value = selectedItems[0].OrderId;
                            this.form.OrderTransItemId.value = selectedItems[0].TransItemId;
                            this.form.Parts.value = selectedItems[0].Parts;
                            this.form.NetWeight.value = selectedItems[0].NetWeight;
                            this.form.TreeId.value = selectedItems[0].TreeId == null ? "0" : selectedItems[0].TreeId.toString();
                            this.form.TreeItemId.value = selectedItems[0].TreeItemId == null ? "0" : selectedItems[0].TreeItemId.toString();
                            this.form.TreeNo.value = selectedItems[0].TreeNo;

                            if (selectedItems[0].OrderTypeId == 16) {
                                let salesdetails: SalesOrder.SalesOrderRow;
                                SalesOrder.SalesOrderService.GetCustomerandProductDetails({ EntityId: this.form.OrderTransId.value }, response => salesdetails = response.Entity, { async: false });

                                this.form.OrderNo.value = salesdetails.VoucherNo;
                                this.form.CustomerName.value = salesdetails.LedgerName;
                               

                            } else if (selectedItems[0].OrderTypeId == 47) {

                                let posdetails: Retail.POSOrderRow;
                                Retail.POSOrderService.GetCustomerandProductDetails({ EntityId: this.form.OrderTransId.value }, response => posdetails = response.Entity, { async: false });

                                this.form.OrderNo.value = posdetails.VoucherNo;
                                this.form.CustomerName.value = posdetails.CustomerName;

                            }

                            let bomdetails: WIPTransactionRow[];
                            WIPTransactionService.MFGBOMList({ BagNo: this.form.BagNo.value }, response => bomdetails = response.Entities, { async: false });
                            var newbomdetails = [];
                            for (var i = 0; i < bomdetails.length; i++) {
                                var value = bomdetails[i];

                                var newbom: ProductionBOMRow = {
                                    AttributeId: value.AttributeId,
                                    ItemTypeId: value.ItemTypeId,
                                    CalcOnId: value.CalcOnId,
                                    ProductCode: value.ProductCode,
                                    Attribute: value.Attribute,
                                    BomProductId: value.ProductId,
                                    BagNo: value.BagNo,
                                    ProductId: value.ProductId,
                                    Pieces: value.Pieces,
                                    Line_No: value.Line_No,
                                    PureWeight: value.PureWeight,
                                    Purity: value.Purity == null ? 0 : value.Purity,
                                    Weight: value.Weight,
                                    KaratId: value.KaratId,
                                    MetalColorId: value.MetalColorId,
                                    ShapeId: value.ShapeId,
                                    QualityId: value.QualityId,
                                    StoneSizeId: value.StoneSizeId,
                                    SieveId: value.SieveId,
                                    RefTransId: value.TransId,
                                    RefVoucherId: value.VoucherTypeId,
                                    IsCustomerItem: value.IsCustomerItem
                                };
                                newbomdetails.push(newbom);

                            }
                            this.form.BOMDetails.setdata(newbomdetails);
                            this.CalculateTotals();
                        }
                    }
                    pickerDialog.dialogOpen();
                }
                else
                    q.Alert("Not Allowed", "Party can not be changed while items are added", 2000, false);
            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }


        private CalculateTotals() {
            var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
            for (var k of this.form.BOMDetails.getItems()) {

                if (k.ItemTypeId == 104) {
                    Wt += k.Weight;
                }
                if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                    cts += k.Weight;
                    diapcs += k.Pieces
                }
                if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                    gms += k.Weight;
                    clrpcs += k.Pieces;
                }

            }
            //alert(cts + '');
            if (cts > 0)
                this.form.Weight.value = Wt + gms + (cts / 5);
            else
                this.form.Weight.value = Wt + gms;

            this.form.NetWeight.value = Wt;

        }

        public SetMaterialInData(item: ProductionBOMRow, issueditem: Stock.JobTransactionRow) {
            issueditem.Weight = (issueditem.Pieces - item.Pieces) * issueditem.PointerWeight;
            issueditem.Pieces = issueditem.Pieces - item.Pieces;

            //this.form.NewBOMDetails.setBOMData(issueditem);
        } 
    }
}